import StepDialog from './Index.vue'

StepDialog.install = function(Vue) {
    Vue.component(StepDialog.name, StepDialog)
}

export default StepDialog
